import { Component, Input } from '@angular/core';
import { Report } from '../../../models/report.model';

@Component({
  selector: 'app-votre-estimation-read-mode',
  templateUrl: './votre-estimation-read-mode.component.html',
  styleUrls: ['./votre-estimation-read-mode.component.scss'],
})
export class VotreEstimationReadModeComponent {
  @Input() appraisal!: Report.Appraisal;
  @Input() reportType!: string;
}
